/* Tecnova product card — swatch interaction (image + link swap) */
(function () {
  if (customElements.get('tc-product-card')) return;

  class TcProductCard extends HTMLElement {
    connectedCallback() {
      this.img = this.querySelector('.tc-card__img--primary');
      this.secondaryImg = this.querySelector('.tc-card__img--secondary');
      this.links = this.querySelectorAll('a[data-tc-product-link]');
      this.swatches = this.querySelectorAll('.tc-swatch');

      this.swatches.forEach((swatch) => {
        swatch.addEventListener('click', (e) => {
          e.preventDefault();
          this.selectSwatch(swatch);
        });
      });
    }

    selectSwatch(swatch) {
      this.swatches.forEach((s) => s.classList.remove('is-active'));
      swatch.classList.add('is-active');

      var src = swatch.dataset.variantImage;
      var srcset = swatch.dataset.variantSrcset;
      if (src && this.img) {
        this.img.src = src;
        if (srcset) this.img.srcset = srcset;
        else this.img.removeAttribute('srcset');
        // Variant images replace the hover image too, so the swap stays visible
        if (this.secondaryImg) this.secondaryImg.style.display = 'none';
      }

      var url = swatch.dataset.variantUrl;
      if (url) {
        this.links.forEach((link) => {
          link.href = url;
        });
      }
    }
  }

  customElements.define('tc-product-card', TcProductCard);
})();
